import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Grid, Paper, TextField, Typography } from '@mui/material';

import { MAILBODY_MAX_CHAR } from '../BulkMailInterfaces';

interface OOEMailComposer {
  rowsCount?: number;
  mailSubject: string;
  setMailSubject: (value: string) => void;
  mailBody: string;
  setMailBody: (value: string) => void;
}

const EmailComposer: React.FC<OOEMailComposer> = ({
  rowsCount = 16,
  mailSubject,
  setMailSubject,
  mailBody,
  setMailBody,
}) => {
  const { t } = useTranslation(['recruiter']);

  useEffect(() => {
    if (mailBody === '') setMailBody(t('recruiter:GENERAL.MAILS.CustomMailBody'));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box p={4}>
      <Grid container spacing={4}>
        <Paper elevation={0} sx={{ p: 3 }}>
          <TextField
            fullWidth
            label={t('recruiter:GENERAL.MAILS.ManualMailSubject')}
            value={mailSubject}
            onChange={(e) => setMailSubject(e.target.value)}
            margin="normal"
          />
          <TextField
            fullWidth
            label={t('recruiter:GENERAL.MAILS.ManualMailBody')}
            multiline
            maxRows={rowsCount}
            value={mailBody}
            onChange={(e) => setMailBody(e.target.value)}
            margin="normal"
          />
          <Typography variant="body2" color="text.secondary">
            {mailBody.length}/{MAILBODY_MAX_CHAR}
          </Typography>
        </Paper>
      </Grid>
    </Box>
  );
};

export default EmailComposer;
